export default function onApiError(e) {
    if (!e.status) {
        return
    }

    switch (e.status) {
        case 401:
            break
    }
}
